import { IUserApiClient, IUserApiClientUrls } from '@/models/api-client/user'
import { LoginParameterInterface } from '@/models/composables'
import { RuntimeConfigsInterface } from '@/models/configs/configs.interface'
import { IHttpRequestParams } from '@/models/http-client'
import { HttpClient } from '@/utils/http-client/HttpClient'

export class UserApiClient implements IUserApiClient {
  private readonly urls!: IUserApiClientUrls

  constructor(urls: IUserApiClientUrls) {
    this.urls = urls
  }

  loginUser(payload: LoginParameterInterface, runtimeConfigs: RuntimeConfigsInterface): Promise<any> {
    return new Promise<LoginParameterInterface>((resolve) => {
      const url = this.urls.loginUser
      const parameters: IHttpRequestParams = {
        path: url,
        payload: payload
      }
      const res: Promise<any> = HttpClient.post(parameters, runtimeConfigs)
      resolve(res)
    })
  }
}
